<template>
  <div :style="{ width: opts.width || '100%', 'padding-left': opts.labelWidth || '55px' }" class="rdv-view-item">
    <label>{{ opts.label }}：</label>
    <i
      v-if="opts.label == '业绩'"
      style="cursor:pointer;position:absolute;top:8px;left:30px"
      class="el-icon-warning"
      @click="$parent.$parent.$refs.DetailEdit.showRecommendYeji"
    ></i>
    <div @dblclick="editing = 'true'" v-if="!editing" style="cursor:pointer;" :title="value.toString()">
      <span v-if="opts.prop == '长期意向'" class="rdv-tag" :style="{ backgroundColor: yiColor() }">{{ yiWord() }}</span>
      <div v-else-if="opts.prop == '简介'">
        <div>{{ !showIntro && value.length > 180 ? value.substr(0, 180) : value }}</div>
        <div v-show="value.length > 180" class="rdv-intro-more" @click="showIntro = !showIntro">
          {{ showIntro ? '收起' : '更多' }}
        </div>
      </div>
      <div v-else-if="opts.type == 'select' || opts.type == 'multSelect'" class="rdv-view-item-text">
        {{ selectWord() }}
      </div>
      <div v-else class="rdv-view-item-text">
        {{ value.toString() }} <span v-if="opts.prop == '出生年月' && value">({{ getAge(value) }})</span>
      </div>
    </div>
    <div v-else :class="{ 'view-item-red': !value || value.length == 0 }">
      <el-select v-if="opts.type == 'select'" v-model="value" size="mini" filterable placeholder="请选择">
        <template v-if="Array.isArray(options[opts.prop])">
          <el-option v-for="op in options[opts.prop]" :value="op" :key="op" :label="op || '--'"></el-option>
        </template>
        <template v-else>
          <el-option v-for="(v, k) in options[opts.prop]" :value="k" :key="k" :label="v || '--'"></el-option>
        </template>
      </el-select>
      <el-select v-else-if="opts.type == 'color'" v-model="value" size="mini" filterable placeholder="请选择">
        <el-option
          v-for="(item, k) in options[opts.prop]"
          :key="k"
          :label="item.word"
          :value="k"
          :style="{ backgroundColor: item.color }"
        ></el-option>
      </el-select>
      <el-select
        v-else-if="opts.type == 'multSelect'"
        v-model="value"
        size="mini"
        filterable
        multiple
        placeholder="请选择"
      >
        <template v-if="Array.isArray(options[opts.prop])">
          <el-option v-for="op in options[opts.prop]" :value="op" :key="op" :label="op || '--'"></el-option>
        </template>
        <template v-else>
          <el-option v-for="(v, k) in options[opts.prop]" :value="k" :key="k" :label="v || '--'"></el-option>
        </template>
      </el-select>
      <el-input
        v-else-if="opts.type == 'textarea'"
        type="textarea"
        :rows="2"
        :autosize="{ minRows: 2, maxRows: 5 }"
        v-model="value"
        placeholder="请填写"
      >
      </el-input>
      <el-checkbox-group v-else-if="opts.type == 'checkbox'" v-model="value">
        <el-checkbox v-for="(op, k) in options[opts.prop]" :label="op" :key="k"></el-checkbox>
      </el-checkbox-group>
      <div v-else class="el-input el-input--mini">
        <input type="text" autocomplete="off" v-model="value" placeholder="请填写" class="el-input__inner" />
      </div>
    </div>
  </div>
</template>

<script>
import { options } from './options'
import { getAge } from '../constant/common-methods'
export default {
  props: {
    opts: Object,
    val: [Array, String, Number],
    handleDataChange: { type: Function, default: function() {} },
  },
  data() {
    return {
      value: '',
      editing: false,
      options,
      showIntro: false,
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      const n = newVal instanceof Object ? JSON.stringify(newVal) : newVal
      const o = oldVal instanceof Object ? JSON.stringify(oldVal) : oldVal
      if (n != o) {
        this.handleDataChange({ label: this.opts.label, val: this.value })
      }
    },
    val: function(newVal, oldVal) {
      const n = newVal instanceof Object ? JSON.stringify(newVal) : newVal
      const o = oldVal instanceof Object ? JSON.stringify(oldVal) : oldVal
      if (n != o) {
        if ((this.type == 'multSelect' || this.type == 'createSelect' || this.type == 'checkbox') && !newVal) {
          this.value = []
        } else {
          this.value = newVal
        }
      }
    },
  },
  methods: {
    yiColor() {
      if (!this.value || !this.options.长期意向[this.value]) {
        return '#ccc'
      }
      return this.options.长期意向[this.value].color
    },
    yiWord() {
      if (!this.value || !this.options.长期意向[this.value]) {
        return '无'
      }
      return this.options.长期意向[this.value].word
    },
    selectWord() {
      if (Array.isArray(this.options[this.opts.prop])) {
        return Array.isArray(this.value) ? this.value.join('、') : this.val
      } else {
        if (Array.isArray(this.value)) {
          return this.value.map(v => this.options[this.opts.prop][v]).join('、')
        } else {
          return this.options[this.opts.prop][this.value]
        }
      }
    },
    getAge(val) {
      return getAge(val)
    },
  },
  created() {
    this.value = Array.isArray(this.val) ? JSON.parse(JSON.stringify(this.val)) : this.val
    if (!this.value || this.value.length == 0) this.editing = true
  },
}
</script>

<style>
.rdv-view-item {
  float: left;
  position: relative;
  line-height: 28px;
  margin-bottom: 5px;
  padding-right: 5px;
}
.rdv-view-item > label {
  position: absolute;
  top: 0;
  left: 0;
  color: #999;
}
.view-item-red .el-input .el-input__inner,
.view-item-red .el-textarea__inner {
  border: 1px solid #f88;
}
.rdv-view-item .el-select {
  width: 100%;
}
.rdv-view-item-text {
  height: 28px;
  overflow: hidden;
  white-space: nowarp;
  text-overflow: ellipsis;
}
</style>
